import { useGetAllFollowingUsersPosts } from "@/hooks/posts/useGetAllFollowingUsersPosts";
import Error from "@/pages/Error/Error";
import React from "react";
import { ArticleSection } from "@/pages/Home/components/ArticleSection/ArticleSection";
import { useInfiniteQueryCntrObserver } from "@/hooks/utils/useInfiniteQueryCntrObserver";
import { PostArticleSkeleton } from "@/components/common/PostArticleSkeleton/PostArticleSkeleton";
import { NotFound } from "@/components/common/NotFound/NotFound";

export const FollowingPosts = () => {
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
    isError,
    isRefetching,
  } = useGetAllFollowingUsersPosts();

  const { lastElement } = useInfiniteQueryCntrObserver({
    hasNextPage,
    isFetching,
    isLoading,
    fetchNextPage,
  });

  if (isError) {
    console.error(error);
    return <Error>Error while loading following posts page !</Error>;
  }
  if (isLoading || isRefetching) {
    return (
      <>
        <PostArticleSkeleton count={4} />
      </>
    );
  }

  const postData = data.pages.map((item) => item.posts).flat();
 const mergedPosts = Object.assign({}, ...postData);
 const totalFetchedPosts = Object.keys(mergedPosts).length;

 
  if (totalFetchedPosts <= 0) {
    return <NotFound>No posts found !</NotFound>;
  }

  return (
    <div data-test={`following-posts-page`}>
      <ArticleSection
        ref={lastElement}
        postData={mergedPosts}
        totalPosts={totalFetchedPosts}
        mutationLocation={"Following"}
      />
      {isFetching ? <PostArticleSkeleton count={4} className="mt-3" /> : null}
    </div>
  );
};
